import axios from 'axios';
import { put, takeLatest, takeEvery } from 'redux-saga/effects';

function* fetchRequests(action) {
    try {
        const response = yield axios.get('/api/requests');
     
        yield put({ type: 'SET_REQUESTS', payload: response.data });
    } catch (error) {
        console.log('Error fetching requests', error);
    }
}

function* appointRequest(action) {
    try {
        yield axios.put(`api/requests/appointment/${action.payload.request_id}`, {
            request_id: action.payload.request_id,
            appointment: action.payload.appointment,
            instructions: action.payload.instructions,
            client_id: action.payload.client_id
        });
        yield put({ type: 'FETCH_REQUESTS' });
         yield put({ type: 'FETCH_NEWEST_REQUESTS' });
          yield put({ type: 'FETCH_NAME_REQUESTS' });
    } catch (error) {
        console.log('Error approving request', error);
    }
}

function* denyRequest(action) {
    try {
        yield axios.put(`api/requests/deny/${action.payload.request_id}`, action.payload);
        yield put({ type: 'FETCH_REQUESTS' });
            yield put({ type: 'FETCH_NEWEST_REQUESTS' });
          yield put({ type: 'FETCH_NAME_REQUESTS' });
    } catch (error) {
        console.log('Error denying request', error);
    }
}

function* returnRequest(action) {
    try {
        yield axios.put(`api/requests/return/${action.payload}`);
        yield put({ type: 'FETCH_REQUESTS' });
            yield put({ type: 'FETCH_NEWEST_REQUESTS' });
          yield put({ type: 'FETCH_NAME_REQUESTS' });
    } catch (error) {
        console.log('Error denying request', error);
    }
}

function* deleteRequest(action) {
    try {
        yield axios.delete(`/api/requests/${action.payload}`);
        yield put({ type: 'FETCH_REQUESTS' });
            yield put({ type: 'FETCH_NEWEST_REQUESTS' });
          yield put({ type: 'FETCH_NAME_REQUESTS' });
    } catch (error) {
        console.log('Error deleting request', error);
    }
}

function* addRequestFormSaga(action) {
    try {
        console.log(`ref partner id`, action.payload.referralPartnerId);
        console.log(`Action.payload is:`, action.payload);
        yield axios.post('/api/requests', {
            //goes to clients table
            //newsletter ?
            newsletter: action.payload.clientNewsletter,
            email: action.payload.clientEmail,
            name: action.payload.clientName,
            phone: action.payload.clientPhone,
            phone_type: action.payload.clientPhoneType,
            address: action.payload.clientAddress,
            dob: action.payload.clientDob,
            gender: action.payload.clientGender,
            race: action.payload.clientRace,
            marital_status: action.payload.clientMaritalStatus,
            education: action.payload.clientEducation,
            veteran: action.payload.clientVeteranStatus,
            ability: action.payload.clientAbility,
            household_head: action.payload.clientHeadOfHousehold,
            household_members: action.payload.clientHouseholdMembers,
            children_number: action.payload.childrenNumber,
            monthly_income: action.payload.clientMonthlyIncome,
            reason: action.payload.clientReason,
            reason_text: action.payload.clientReasonText,
            //goes to requests table:
            staff_name: action.payload.staffName,
            staff_email: action.payload.staffEmail,
            request_items: action.payload.requestedItems,
            referral_partner_id: action.payload.referralPartnerId,
        });
        yield put({ type: 'FETCH_REQUESTS' });
            yield put({ type: 'FETCH_NEWEST_REQUESTS' });
          yield put({ type: 'FETCH_NAME_REQUESTS' });
    } catch (error) {
        console.log('Error in add', error);
    };
};

function* requestSaga() {
    yield takeEvery('FETCH_REQUESTS', fetchRequests);
    yield takeEvery('APPOINT_REQUEST', appointRequest);
    yield takeEvery('DENY_REQUEST', denyRequest);
    yield takeEvery('RETURN_REQUEST', returnRequest);
    yield takeEvery('ADD_REQUEST_DATA', addRequestFormSaga);
    yield takeEvery('DELETE_REQUEST', deleteRequest);
}
export default requestSaga;